'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import cmsItemsArrayIsEqual from '@haaretz/s-common-utils/cmsItemsArrayIsEqual';
import React from 'react';
const TagsContext = /*#__PURE__*/ React.createContext(undefined);
const TagsSetter = /*#__PURE__*/ React.createContext(undefined);
export function TagsProvider({ children, value: defaultTags }) {
    const [tags, setTags] = React.useState(defaultTags);
    const tagsSetter = React.useCallback((value)=>{
        if ((Array.isArray(value) || value === null) && !cmsItemsArrayIsEqual(value, tags)) {
            setTags(value);
        } else if (value && !Array.isArray(value) && typeof value === 'object' && Object.keys(value).length && !cmsItemsArrayIsEqual([
            value
        ], tags)) {
            setTags([
                value
            ]);
        }
    }, [
        tags
    ]);
    return /*#__PURE__*/ _jsx(TagsContext, {
        value: tags,
        children: /*#__PURE__*/ _jsx(TagsSetter, {
            value: tagsSetter,
            children: children
        })
    });
}
export default function useTags() {
    const context = React.use(TagsContext);
    if (context === undefined) {
        throw new Error('useTags must be used within a TagsProvider');
    }
    return context;
}
export function useSetTags() {
    const context = React.use(TagsSetter);
    if (context === undefined) {
        throw new Error('useSetTags must be used within a TagsProvider');
    }
    return context;
}
export function useTagsAtom() {
    return [
        useTags(),
        useSetTags()
    ];
}

//# sourceMappingURL=tagsAtom.js.map